import declare from "dojo/_base/declare";
import Controller from "csi/action/Controller";
import PostRequest from "csi/comm/PostRequest";
import xml from "csi/xml";

export = declare(Controller, {
	/**
	 * @override
	 * Use PostRequest to send request to server in order to get return value from Java operation
	 * rather than the standard new/modified nodes using a NODES_OPERATION xml script.
	 * 
	 * The XML action would look something like this:
	 * <Action Id="X" ControllerClass="csi/action/PostRequestController">
	 * 		<Request Module="Apparel" Operation="SomeOperation">
	 * 			<Parameter Id="Y" Value="Z" />
	 * 		</Request>
	 * </Action>
	 * 
	 * The client will pass all Parameters specified for the Request, as well as the URL and ParentURL
	 * parameters based on where the action is executed.
	 * 
	 * A ViewRef can be specified to select nodes and pass along to operation in the AddURLs parameter.
	 */
	process(): void {
		const {
			m_action: { m_id, m_request },
			m_formData,
			m_urlNode,
			m_urlParent,
		} = this;

		if (m_request) {
			const { m_module, m_operation, m_parameters } = m_request;
			const value = m_formData?.getSelectedValue();

			const request = new PostRequest(m_module, m_operation)
				.addParameter(xml.PROP_URL, m_urlNode)
				.addParameter(xml.PROP_URL_PARENT, m_urlParent);

			if (m_parameters) {
				for (const { m_id, m_value } of m_parameters) {
					request.addParameter(m_id, m_value);
				}
			}

			if (value?.length) {
				request.addParameter(xml.PROP_AGGREGATE_ADDS, value);
			}

			this.waitForPublish(request.post());
		} else {
			console.warn(`PostRequestController: request not configured for action "${m_id}"`);
			this.inherited(arguments);
		}
	},
});
